export const UPDATE_LANGUAGE = 'update language'
export const UPDATE_LOADER = 'update loader'
export const UPDATE_AUTH_USER = 'update_auth_user'
export const UPDATE_USER_EMAIL = 'update_user_name'
export const TOGGLE_MENU = 'menu_toggle'
export const SELECT_PRODUCT = 'select_product'
export const GET_STATUS = 'get_status'
export const SELECT_ASSET = 'select_asset'
export const GET_DEVICE_DATA = 'get_device_data'
export const GET_ASSET_DATA = 'get_asset_data'
export const ADD_CUSTOMER_GROUPS = 'add_customer_groups'
export const ADD_CUSTOMER_ASSETS_LIST = 'add_customer_assets_list'
export const REFRESH_CUSTOMER_DEVICES = 'refresh_customer_devices'
export const ADD_CUSTOMER_TEMPLATES = 'add_customer_templates'
export const REFRESH_CUSTOMER_TEMPLATES = 'refresh_customer_devices'
export const REFRESH_CUSTOMER_ASSETS = 'refresh_customer_assets'
export const ADD_ASSET_TYPE = 'add_asset_type'
export const ADD_HIERARCHY = 'add_hierarchy'
export const ADD_COUNTRIES = 'add_countries'
export const ADD_REGIONS = 'add_regions'
export const ADD_FACILITIES = 'add_facilities'
export const ADD_FROM_RELATION = 'add_from_relation'
export const REFRESH_USER_CUSTOMERS = 'refresh_user_customers'
export const SELECT_CUSTOMER = 'select_customer'
export const CHANGE_CUSTOMER_STATUS = 'change_customer_status'
export const SET_CUSTOMER_DATA = 'set_customer_data'
export const SET_CUSTOMER_LIST = 'set_customers_list'
export const SET_VIEW_CUSTOMER = 'set_view_customer'
export const UPDATE_USER_PRODUCTS = 'update_user_products'
export const REFRESH_USER_FACILITIES = 'refresh_user_facilities'
export const SELECT_FACILITY = 'select_facility'
export const SET_VIEW_FACILITY = 'set_view_facility'
export const SET_EMAIL = 'set_email'
export const UPDATE_USER_ROLE = 'set_user_role'
export const ADD_CUSTOMERID = 'add_customer_id'
export const GET_DEVICE_CUSTOMER_ID = 'add_device_customer_id'
export const FACILITY_CUSTOMERID = 'add_facility_customer_id'
export const FACILITY_CUSTOMERNAME = 'add_facility_customer_name'
